import createAction from '../services/create-action';

export const ADD_USER = 'user/ADD';
export const addUser = createAction(ADD_USER);



// WEBPACK FOOTER //
// ./app/actions/add-user.js